module.exports = __webpack_public_path__ + "img/yqBg.8008db26.png";